import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FlatList from "flatlist-react/lib";
import Modal from "react-bootstrap/Modal";
import RADIOACTIVE from "../../images/radio_active.svg";
import RADIOBASE from "../../images/radio_base.svg";
import AppStyles from "../../config/styles";
import {TemplateListContainer , AddChildCloseIcon, BtnViewStyles, TemplateDesc,
     TemplateItem, TemplateHeading, Templateiconstylehead, Templatetextstylehead,} from "../atoms/ConnectStories";
import BibleIcon from "../../images/Bible_new_icon.svg";
import "../../styles/ConnectScreen.css";
import { BibleWrapper } from "../atoms/Menu";

function BibleModal(props) {
  const { t } = useTranslation();
  const [selectedBibleVerse, setSelectedBibleVerse] = useState(null);
  const [bibleList, setBibleList] = useState(null);
  const styles = {
    horizontalBarStyles: {
        alignSelf: "center",
        backgroundColor: AppStyles.colors.COLOR_GREYE6,
    },
    imgStyles: {
        alignSelf: "center",
      marginVertical: "20px",
    },
    headerTextStyles: {
        fontFamily: "Lato",
        fontSize: "24px",
        color: "rgba(0,0,0,1)",
        textAlign: "center",
    },
    
    listStyles: {
        height: "200px",
        marginBottom:"25px",
    },
    itemViewStyles: {
        display: "flex",
        borderBottom: "1px solid rgba(230, 230, 230, 1)",
        padding: "10px",
    },
    itemContentStyles: {
        padding: "0 15px",
    },
    titleStyles: {
        fontFamily: "Lato-Bold",
        fontSize: "18px",
        color: "rgba(51,51,51,1)",
    },
    btnLabelStyles: {
        color: "rgba(255,255,255,1)",
        fontFamily: "Lato-Bold",
        fontSize: "20px",
        cursor:"pointer"
    },
    radioButtons: {
      maxHeight: "15px",
      marginTop:"5px",
      cursor:"pointer"
    }
  };

  const selectedItem = (item, index) => {
    setSelectedBibleVerse(item);
    const objIndex = bibleList
      .findIndex((obj) => obj.isSelected);
    if (objIndex > -1) {
      bibleList[objIndex].isSelected = false;
    }
    bibleList[index].isSelected = !bibleList[index].isSelected;
  };

  useEffect(() => {
    if (props?.bibleData && props?.bibleData?.length > 0) {
      setBibleList(props?.bibleData);
    }
  }, [props?.bibleData]);

  useEffect(() => {
    bibleList &&
    selectedItem(bibleList[0], 0)
  }, [bibleList]);
  
  const renderList = (item, index) => {
    const { title, body } = item;
    return (
      <TemplateItem onClick={() => selectedItem(item, index)} style={styles.itemViewStyles}>
          <img style={styles.radioButtons} src={item?.isSelected ? RADIOACTIVE  : RADIOBASE} alt=""/>
          <div style={styles.itemContentStyles}>
            <div style={styles.titleStyles}>{title}</div>
            <TemplateDesc>{body}</TemplateDesc>
          </div>
      </TemplateItem>
    );
  };
  return (
    <Modal
      className="bible-popup"
      show={props?.isVisible}
      dialogClassName="custom-modal-width"
    >
    <AddChildCloseIcon  onClick={props?.setVisibility}>X</AddChildCloseIcon>
      <>
        <TemplateHeading>
            <Templateiconstylehead>
              <img src={BibleIcon} alt="" />
            </Templateiconstylehead>
            <Templatetextstylehead>{t("AddBible")}</Templatetextstylehead>
        </TemplateHeading>
        <BibleWrapper>
        <TemplateListContainer className="bible-list-container">
            <FlatList
            style={styles.listStyles}
            list={bibleList}
            renderItem={renderList}
            keyExtractor={(item) => item.artifactID}
            showsVerticalScrollIndicator={false}
            />
            </TemplateListContainer>
            <BtnViewStyles onClick={() => props?.addBibleVerse(selectedBibleVerse)}>
              <span style={styles.btnLabelStyles}>{t("Add")}</span>
            </BtnViewStyles>
        </BibleWrapper>       
      </>
    </Modal>
  );
}
export default BibleModal;
